import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ModalDismissReasons, NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { shadowType } from 'src/app/core/const/settings';
import { IClientModel } from 'src/app/core/models/application.model';
import { IBackgroundModel } from 'src/app/core/models/background.model';
import { IFeatureModel } from 'src/app/core/models/feature.model';
import { IPreset } from 'src/app/core/models/preset.model';
import { Role } from 'src/app/core/models/role';
import { IUser } from 'src/app/core/models/user.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { BackgroundService } from 'src/app/core/services/background.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { FeatureService } from 'src/app/core/services/feature.service';
import { PresetService } from 'src/app/core/services/preset.service';
import { AddCustomerComponent } from 'src/app/shared/components/modals/add-customer/add-customer.component';

@Component({
  selector: 'app-customer-item',
  templateUrl: './customer-item.component.html',
  styleUrls: ['./customer-item.component.css']
})
export class CustomerItemComponent implements OnInit {

  @ViewChild('dialogAddCustomerCredit')
  public dialogAddCustomerCredit: TemplateRef<any>;
  @ViewChild('dialogEditCustomer')
  public dialogEditCustomer: TemplateRef<any>;
  @ViewChild('dialogAddCustomer') 
  public dialogAddCustomer: AddCustomerComponent;

  searchText = '';

  customerId: string;
  subcustomers: any[] = [];
  customer = null;
  admins;
  currentUser;

  toggleAddAdmin = false;
  toggleAddCustomer = false;

  editCustomer;
  editAdmin;
  modalEditCustomer
  modalDeleteCustomer
  modalEditAdmin
  private dialogOptions: NgbModalOptions = {
    backdropClass: 'dark-backdrop',
    centered: true,
    windowClass: 'window-modal'
  };

  applications: IClientModel[];
  selectedApp: IClientModel = null;
  selectedUser: IUser = null;
  searchParam = '';
  users: IUser[];
  usersDataSearch: IUser[] = [];
  page = 1;
  perPage = 16;
  toggleAddUser = false;
  userToAddCredit: IUser;
  modalAddUserCredit;
  modalDeleteUser;
  customerToAddCredit;
  isLoading = false;

  canSeeAdmins: boolean;

  customerFeatures;
  features;
  toggleFeaturePrice = false;
  eventsSubject: Subject<void> = new Subject<void>();
  removeReflectionSubject: Subject<void> = new Subject<void>();
  shadowType = shadowType;

  isInteriorBgVisible: boolean = false;
  isFillableImageVisible: boolean = false;
  isPreprocessingVisible: boolean = false;
  isCrossClientSearch: boolean = false;
  isCrossClientSearchControl: boolean = false;
  licensePlateNumberEnabled: boolean = false;

  constructor(
    private customerService: CustomerService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private translate: TranslateService,
    private authService: AuthService,
    private backgroundService: BackgroundService,
    private presetService: PresetService,
    private featureService: FeatureService
  ) { }

  ngOnInit(): void {

    this.translate.get(['global.loading', 'user.selectPreset', 'user.selectBackgrounds']).subscribe((values) => {
      console.log(values)
      const translation = (Object.keys(values).map(key => values[key]));
      // this.selectedBackground = translation[2];
    });

    this.authService.LoggedinUser.subscribe(
      user => {
        this.currentUser = user;
      }
    );

    this.route.params.subscribe((params: Params) => {
      this.customerId = params.customerId || this.currentUser.customerId;
      this.isLoading = true;
      this.canSeeAdmins = params.customerId ? true : false;
      this.loadCustomer();
      this.updateVisibilityFlags();

      if (this.canSeeAdmins) {
        if (this.currentUser.role.name === Role.ROOT) {
          this.loadAllBackgrounds().subscribe(res => {
            this.backgroundService.setAllNewBackgrounds(res);
          })
          this.loadCustomerBackgrounds(this.customerId).subscribe(res => {
            this.backgroundService.setNewBackgrounds(res);
          })
          this.loadPresets().subscribe(res => {
            this.presetService.setAllPresets(res)
          })
          this.loadCustomerPresets(this.customerId).subscribe(res => {
            this.presetService.setSelectedPresets(res);
          })
        } else {
          this.loadCustomerBackgrounds(this.currentUser.customerId).subscribe(res => {
            this.backgroundService.setAllNewBackgrounds(res);
          })
          this.loadCustomerBackgrounds(this.customerId).subscribe(res => {
            this.backgroundService.setNewBackgrounds(res);
          })

          this.loadCustomerPresets(this.currentUser.customerId).subscribe(res => {
            this.presetService.setAllPresets(res)
          })
          this.loadCustomerPresets(this.customerId).subscribe(res => {
            this.presetService.setSelectedPresets(res)
          })
        }

        forkJoin({
          customerFeatures: this.loadCustomerFeaturesPrice(),
          features: this.loadFeatures()
        }).subscribe(
          res => {
            this.customerFeatures = res.customerFeatures;
            this.features = res.features;
          }
        );
      }
    });
  }

  loadCustomerFeaturesPrice(): Observable<any> {
    return this.featureService.getCustomerFeatures(this.customerId);
  }

  loadFeatures() {
    const filterOptions = {
      excludeNames: ['createVehicle', 'decodeVin']
    }
  
    return this.featureService.getFeatures(filterOptions)
      .pipe(
        map((res: IFeatureModel[]) => {
          return res;
        })
      );
  }

  loadCustomer() {
    this.customerService.get(this.customerId)
      .subscribe(
        res => {

          this.customer = res;
          if (res.customers) {
            this.subcustomers = res.customers;
          }
          this.loadCustomerAdmins(this.customer.id);
        },
        err => {
          this.isLoading = false;
        }
      );
  }

  reloadCustomer(e) {
    this.loadCustomer();
  }

  customerAdminPage = 1 ;
  customerAdminPerPage = 3;
  loadCustomerAdmins(customerId: string) {
    this.customerService.getCustomerAdmins(customerId, this.customerAdminPage, this.customerAdminPerPage)
      .subscribe(
        res => {
          this.admins = res;
          this.isLoading = false;
        },
        err => {
          this.isLoading = false;
        }
      );
  }

  jumpToCustomerAdminPage(event) {
    this.customerAdminPage = event;
    this.loadCustomerAdmins(this.customer.id);
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  async openAddCustomerModal() {
    return await this.dialogAddCustomer.open()
  }

  isAdding = false;
  sendCustomer(form: NgForm) {
    if (!form.form.valid) {
      this.translate.get('errors.pleaseFillRequiredFields').subscribe((text: string) => {
        this.toastr.error(text);
      });
      return;
    }

    this.toggleAddCustomer = false;
    this.isAdding = true;

    if (this.currentUser.role.name !== Role.ROOT) {
      delete form.form.value['allowNegativeCredits'];
    }

    this.customerService.add(form, this.customerId).subscribe(response => {
      this.toastr.success('Successfully added Subcustomer');

      let newCustomer = response;
      newCustomer.customers = [];
      newCustomer.credits = null;
      this.subcustomers.unshift(newCustomer);
      this.dialogAddCustomer.close();

      this.isAdding = false;
    }, error => {
      this.isAdding = false;
      this.toastr.error(error.message);
    });
  }

  addAdmin(form: NgForm) {
    if (!form.form.valid) {
      this.translate.get('errors.pleaseFillRequiredFields').subscribe((text: string) => {
        this.toastr.error(text);
      });
      return;
    }

    const customerId = this.customer.id;

    this.customerService.addAdmin(form, customerId)
      .subscribe(
        res => {

          this.toastr.success(`Admin ${res.name} added.`);
          this.admins.results.push(res);
          this.toggleAddAdmin = false;
        },
        err => {
          this.translate.get('errors.pleaseFillRequiredFields').subscribe((text: string) => {
        this.toastr.error(text);
      });

        }
      );
  }

  showDialogEditAdmin(content, admin) {
    this.editAdmin = admin;
    this.modalEditAdmin = this.modalService.open(content, this.dialogOptions);
    this.modalEditAdmin.result.then((result) => {

    }, (reason) => {

    });
  }

  reloadEditCustomer(data) {
    const index = this.subcustomers.map(e => { return e.id; }).indexOf(data.customer.id);

    if (index !== -1) {
      this.subcustomers[index] = data.customer;
    }
    this.customer.credits -= data.transferCredit;
  }

  reloadDeleteCustomer(editCustomerId: string) {
    const customerToDelete = this.subcustomers.find(customer => customer.id === editCustomerId);
    if (customerToDelete !== undefined) {
      this.customer.credits += customerToDelete.credits;
      this.subcustomers.splice(this.subcustomers.indexOf(customerToDelete), 1);

    }
  }

  sendEditAdmin(form: NgForm) {
    if (!form.form.valid) {
      return this.translate.get('errors.fillAllFields').subscribe((text: string) => {
            this.toastr.error(text);
          });
    }

    const editData = form.form.value;

    let body = {};

    Object.keys(this.editAdmin).forEach(key => {
      if (key in editData) {
        if (this.editAdmin[key] !== editData[key]) {
          body[key] = editData[key] === '' ? null : editData[key];
        }
      }
    });

    if (Object.keys(body).length === 0 && body.constructor === Object) {
      console.info('No changes.');
      return;
    }

    this.customerService.updateCustomerAdmin(this.customerId, this.editAdmin.id, body)
      .subscribe(
        user => {
          this.translate.get('settings.userUpdatedInfo').subscribe((text: string) => {
            this.toastr.success(text);
          });

          const index = this.admins.results.map(e => { return e.id; }).indexOf(user.id);

          if (index !== -1) {
            this.admins.results[index] = user;
          }

          this.modalEditAdmin.close();

        },
        error => {

          this.toastr.error(error.message);
        });
  }

  adminToDelete(content) {
    this.modalDeleteCustomer = this.modalService.open(content, this.dialogOptions);
    this.modalEditAdmin.close();
  }

  deleteAdmin() {
    this.customerService.deleteCustomerAdmin(this.customerId, this.editAdmin.id).subscribe(response => {
      this.modalDeleteCustomer.close();

      const adminToDelete = this.admins.results.find(admin => admin.id === this.editAdmin.id);

      if (adminToDelete !== undefined) {

        this.admins.results.splice(this.admins.results.indexOf(adminToDelete), 1);

        this.editAdmin = null;
      }

      this.toastr.success('Admin deleted.');

    }, error => {
      this.toastr.error(error.message);
    });
  }

  // BACKGROUNDS
  loadAllBackgrounds(): Observable<IBackgroundModel[]> {
    return this.backgroundService.getAll();
  }
  loadCustomerBackgrounds(customerId): Observable<IBackgroundModel[]> {
    return this.backgroundService.getCustomerBackgrounds(customerId);
  }
  addBackground(backgroundId) {
    this.backgroundService.addCustomerBackgrounds(this.customerId, backgroundId)
      .subscribe(
        res => {
          this.toastr.success('background added.');
          this.backgroundService.setNewBackgrounds(res);
          this.emitEventToChild();
        },
        error => {
          this.toastr.error(error.message);
        });
  }

  deleteBackground(BgToDeleteId) {
    this.backgroundService.deleteCustromerBackground(this.customerId, BgToDeleteId).subscribe(res => {
      this.toastr.success('Background removed.');
      this.emitEventToChild();
    }, error => {
      this.toastr.error(error.message);
    });
  }

  // ---- PRESETS

  loadPresets(): Observable<IPreset[]> {
    return this.presetService.getPresets();
  }
  loadCustomerPresets(customerId): Observable<IPreset[]> {
    return this.presetService.getCustomerPresets(customerId);
  }

  addPreset(presetId) {
    this.presetService.addCustomerPreset(this.customerId, presetId)
      .subscribe(
        (res) => {
          this.translate.get('user.presetAdded').subscribe((text: string) => {
            this.toastr.success(text);
          });
          this.presetService.setSelectedPresets(res);
          this.emitEventToChild();
        },
        error => {
          this.toastr.error(error.message);
        });
  }

  emitEventToChild() {
    this.eventsSubject.next();
  }

  emitRemoveReflectionToChild() {
    this.removeReflectionSubject.next();
  }

  deletePreset(presetsId) {
    this.presetService.deleteCustromerPreset(this.customerId, presetsId)
      .subscribe(
        res => {
          this.translate.get('user.presetRemoved').subscribe((text: string) => {
            this.toastr.success(text);
          });
          this.emitEventToChild();
        },
        error => {
          this.toastr.error(error.message);
        });
  }

  setCredit(credit) {
    this.customer.credits -= credit;
  }

  customerPage = 1;
  customerPerPage = 6;
  jumpToCustomersPage(event: any) {
    this.customerPage = event;
  }

  backgroundPage = 1;
  backgroundPerPage = 6;
  jumpToBackgroundPage(event: any) {
    this.backgroundPage = event;
  }

  addFeaturePrice(form: NgForm) {
    if (!form.valid) {
      this.translate.get('errors.fillAllFields').subscribe((text: string) => {
            this.toastr.error(text);
          });
      return;
    }

    const {
      featureId,
      price
    } = form.form.value;

    let body = {
      featureId,
      price
    }

    this.featureService.addPriceForCustomer(this.customerId, body)
      .subscribe(
        res => {
          this.loadCustomerFeaturesPrice().subscribe(
            features => {
              this.customerFeatures = features;
              this.toggleFeaturePrice = false;
            });
        },
        err => {
          this.toggleFeaturePrice = false;
        }
      );
  }

  togglePrice
  editFeaturePrice;
  onEditPrice(feature) {
    this.editFeaturePrice = feature;
    this.togglePrice = true;
  }

  editPrice(form) {
    if (!form.valid) {
      this.translate.get('errors.fillAllFields').subscribe((text: string) => {
            this.toastr.error(text);
          });
      return;
    }

    const {
      price
    } = form.form.value;

    let body = {
      price
    }

    this.featureService.updatePriceForCustomer(this.customerId, this.editFeaturePrice.id, body)
      .subscribe(
        res => {
          this.loadCustomerFeaturesPrice().subscribe(
            features => {
              this.customerFeatures = features;
              this.togglePrice = false;
            });
        },
        err => {
          this.togglePrice = false;
        }
      );
  }

  deletePrice(feature) {
    this.featureService.deleteCustomerPrice(this.customerId, feature.id)
      .subscribe(
        res => {
          this.toastr.success('Price deleted.');
          this.loadCustomerFeaturesPrice().subscribe(
            features => {
              this.customerFeatures = features;
            });
        }
      );
  }

  changeLegacyChadow(event) {
    const shadowType = event.target.value;

    const body = {
      shadowType,
    };

    this.customerService.patch(body, this.customer.id).subscribe(
      (res) => {
        this.isLoading = false;

        this.toastr.success('Success');
      },
      (err) => {
        this.translate.get('errors.error').subscribe((text: string) => {
            this.toastr.error(text);
          });
        this.isLoading = false;
      }
    );
  }

  switchRemoveReflections(event) {
    let status = event.target.checked;

    let body = {
      removeReflectionsEnabled: status,
    };

    this.customerService.patch(body, this.customer.id).subscribe(
      (res) => {
        this.toastr.success('Updated');
        this.emitRemoveReflectionToChild()
      },
      (err) => {
        this.translate.get('errors.error').subscribe((text: string) => {
            this.toastr.error(text);
          });
      }
    );
  }

  switchVinDecode(event) {
    let status = event.target.checked;

    let body = {
      automaticVinDecodeEnabled: status,
    };

    this.customerService.patch(body, this.customer.id).subscribe(
      (res) => {
        this.toastr.success('Updated');
      },
      (err) => {
        this.translate.get('errors.error').subscribe((text: string) => {
            this.toastr.error(text);
          });
      }
    );
  }

  switchGeoLocation(event) {
    let status = event.target.checked;

    let body = {
      geoLocationEnabled: status,
    };

    this.customerService.patch(body, this.customer.id).subscribe(
      (res) => {
        this.toastr.success('Updated');
      },
      (err) => {
        this.translate.get('errors.error').subscribe((text: string) => {
            this.toastr.error(text);
          });
      }
    );
  }

  switchDuplicateCar(event) {
    let status = event.target.checked;

    let body = {
      duplicateVehicleEnabled: status,
    };

    this.customerService.patch(body, this.customer.id).subscribe(
      (res) => {
        this.toastr.success('Updated');
        this.customer.duplicateVehicleEnabled = status; 
      },
      (err) => {
        this.translate.get('errors.error').subscribe((text: string) => {
            this.toastr.error(text);
          });
      }
    );
  }


  guidelineLink() {
    let body = {
      guidelineLink: this.customer.guidelineLink
    };

    this.customerService.patch(body, this.customer.id).subscribe(
      (res) => {
        this.toastr.success('Updated');
      },
      (err) => {
        this.translate.get('errors.error').subscribe((text: string) => {
            this.toastr.error(text);
          });
      }
    );
  }

  updateCustomer(propName: string, value: any) {
    let body = {};
    body[propName] = value;
  
    this.customerService.patch(body, this.customer.id).subscribe(
      (res) => {
        this.toastr.success('Updated');
      },
      (err) => {
        this.translate.get('errors.error').subscribe((text: string) => {
            this.toastr.error(text);
          });
      }
    );
  }

  updateSetting(event, settingName: string) {
    let status = event.target.checked;
    let body = {};
    body[settingName] = status;
  
    this.customerService.patch(body, this.customer.id).subscribe(
      (res) => {
        this.toastr.success('Updated');
        this.loadCustomer();
      },
      (err) => {
        this.translate.get('errors.error').subscribe((text: string) => {
            this.toastr.error(text);
          });
      }
    );
  }

  updateVisibilityFlags() {
    const role = this.currentUser.role.name;
    const customer = this.currentUser.customer;
    const canSeeAdmins = this.canSeeAdmins;
    const currentCustomer = this.customer || this.currentUser.customer;
    const visibilityMap = {
      root: {
        isInteriorBgVisible: true,
        isFillableImageVisible: true,
        isPreprocessingVisible: true,
        isCrossClientSearch: true,
        isCrossClientSearchControl: true,
        licensePlateNumberEnabled: true
      },
      customer: {
        isInteriorBgVisible: customer?.interiorBackgroundEnabled && canSeeAdmins,
        isFillableImageVisible: customer?.fillableImageEnabled && canSeeAdmins,
        isPreprocessingVisible: customer?.preprocessingEnabled && canSeeAdmins,
        isCrossClientSearchControl: currentCustomer?.crossClientSearchControlEnabled && canSeeAdmins,
        isCrossClientSearch: currentCustomer?.crossClientSearchControlEnabled && canSeeAdmins,
        licensePlateNumberEnabled: currentCustomer?.licensePlateNumberEnabled && canSeeAdmins,
      },
    };
  
    const defaultVisibility = {
      isInteriorBgVisible: false,
      isFillableImageVisible: false,
      isPreprocessingVisible: false,
      isCrossClientSearch: false,
      isCrossClientSearchControl: false,
      licensePlateNumberEnabled: false,
    };
  
    const visibility = visibilityMap[role] || defaultVisibility;
  
    this.isInteriorBgVisible = visibility.isInteriorBgVisible;
    this.isFillableImageVisible = visibility.isFillableImageVisible;
    this.isPreprocessingVisible = visibility.isPreprocessingVisible;
    this.isCrossClientSearchControl = visibility.isCrossClientSearchControl;
    this.isCrossClientSearch = visibility.isCrossClientSearch;
    this.licensePlateNumberEnabled = visibility.licensePlateNumberEnabled;
  }

  conflictNotify(settingName: string) {
    const currentCustomer = this.customer || this.currentUser.customer;
    if(settingName === 'threeSixtyVideo' && currentCustomer.createGifEnabled === true) {
      this.translate.get('settings.gifConflictMsg').subscribe((text: string) => {
        this.toastr.info(text)
      });
      return true;
    }
    if(settingName === 'createGifEnabled' && currentCustomer.threeSixtyVideo === true) {
      this.translate.get('settings.videoConflictMsg').subscribe((text: string) => {
        this.toastr.info(text)
      });
      return true;
    }
  }

}
